import { render, staticRenderFns } from "./LedgerBankList.vue?vue&type=template&id=3eb4a5d8&"
import script from "./LedgerBankList.vue?vue&type=script&lang=js&"
export * from "./LedgerBankList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports